module.exports = "/_next/static/images/Scale@2x-f5e62f9cca31f77957c47ab993c2e928.webp";